import { render, staticRenderFns } from "./SelfServiceDeadlines.vue?vue&type=template&id=f7a1c5c8"
import script from "./SelfServiceDeadlines.vue?vue&type=script&lang=js"
export * from "./SelfServiceDeadlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports